/**
 * Template Service
 * Register Angular Services for Tempaltes
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Template', ['$resource', function($resource){
    return $resource('/api/v2/template/:id');
}]);
